const getErrorFromPromiseReason = (reason: any) => reason?.response?.data?.detail || 'Server error. Please try again';

export default getErrorFromPromiseReason;
